const loaders: { [key: string]: Promise<void> } = {};

const loadJS = (source: string) => {
    if (!loaders[source])
        loaders[source] = new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');

            script.src = source;

            script.async = true;

            script.onload = () => resolve();

            script.onerror = reject;

            document.body.appendChild(script);
        });

    return loaders[source];
};

const loader = { loadJS };

export default loader;
